import { type ResourcesConfig } from 'aws-amplify';
import { env } from '@/config/env';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      loginWith: {
        email: true,
      },
      userPoolClientId: env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
      userPoolId: env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
    },
  },
};
